import { useEffect } from 'react';

/**
 * Schlankes Modal mit Backdrop. Schließt bei Klick auf den Backdrop
 * oder Escape-Taste.
 *
 * Props:
 *  - title: string
 *  - onClose: () => void
 *  - footer: ReactNode (optional)
 *  - children: ReactNode
 */
export default function Modal({ title, onClose, footer, children }) {
    useEffect(() => {
        function onKey(e) {
            if (e.key === 'Escape') onClose();
        }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    function handleBackdrop(e) {
        if (e.target === e.currentTarget) onClose();
    }

    return (
        <div className="modal-backdrop" onMouseDown={handleBackdrop}>
            <div className="modal" role="dialog" aria-modal="true">
                <div className="modal__header">
                    <div className="modal__title">{title}</div>
                    <button type="button" className="modal__close" onClick={onClose} aria-label="Schließen">
                        ×
                    </button>
                </div>
                <div className="modal__body">{children}</div>
                {footer && <div className="modal__footer">{footer}</div>}
            </div>
        </div>
    );
}
